/**
 * Bingo Scheduler Portlet Model
 */

define(function(require, exports, module) {
    'use strict';

    var _ = require('underscore');
    var $ = require('j');
    var core = require('core');
    var BingoSchedulerView = require('portlets/bingo-scheduler/bingo-scheduler.view');
    var BingoSchedulerCollection = require('portlets/bingo-scheduler/bingo-scheduler.collection');
    var PortletModel = require('modules/portlet/portlet.model');
    var lazyLoadFactory = require('modules/lazyload/lazyload.module');
    var bingoSchedulerUtil = require('portlets/bingo-scheduler/bingo-scheduler.util');

    module.exports = PortletModel.extend({

        getView: BingoSchedulerView,

        gameCollection: new BingoSchedulerCollection(),

        defaults: {
            bingoVersion: 1.6
        },

        initialize: function() {
            PortletModel.prototype.initialize.apply(this, arguments);

            // Lazy loading enables only on mobile image view. So no need to dynamically enabling it.
            this.lazyLoader = lazyLoadFactory({
                onLoad: this._onLazyLoad.bind(this)
            });
            // Lazy load will have own number of items per page.
            this.itemCount = this.get('config').numbersOfRoom;

            this.doRequest({immediately: true});
        },

        subscribe: function() {
            this.listenTo(core, 'bingoScheduler:changeFilter', this.changeFilterRequest.bind(this));
            this.on('change:currentFetchParams', this.changeCurrentFetchParams.bind(this));
            this.gameCollection.on('remove', this.handleLazyLoad.bind(this));
        },

        doRequest: function(options) {

            options = options || {};

            var _fetch = function() {
                delete options.immediately;

                this.fetch(options)
                    .done(this.handleSuccessResponse.bind(this))
                    .fail(this.handleErrorResponse.bind(this));
            }.bind(this);

            //latency between end timer and getting actual bingo games
            if (!options.immediately) {
                return setTimeout(_fetch, 200);
            }

            _fetch();
        },

        changeCurrentFetchParams: function() {
            this.doRequest({immediately: true});
        },

        handleSuccessResponse: function(response) {
            this.saveData(response);
            this.options.success(response);
        },

        handleErrorResponse: function(response) {
            if (response.data && response.data.message) {
                this.trigger('respondedWithError', response.data.message);
            }

            this.options.error(response);
        },

        saveData: function(response) {
            this.gameCollection.reset(response.siteSchedules, { parse: true });
            this.set(_.pick(response, 'allCount', 'currentPage'));
            this.trigger('change:gameCollection');
        },

        handleLazyLoad: function(options) {
            options.isLazy ? this._onLazyLoad() : this.doRequest();
        },

        changeFilterRequest: function(params) {
            var currentParams = this.get('currentFetchParams');

            params = _.object([params]);

            if (!_.isEqual(currentParams, params)) {
                this.set('currentFetchParams', _.extend({}, currentParams, params, { pageNumber: 1 }));
            }
        },

        _onLazyLoad: function() {
            var lazyRequest = $.Deferred();
            var numberOfRoom = this.get('config').numbersOfRoom;

            this.itemCount += numberOfRoom;

            this.doRequest({
                success: function(model) {
                    var allCount = model.get('allCount');

                    if (this.itemCount >= allCount) {
                        // save maximum count of items if collection reset & fetch again without lazyLoading
                        this.itemCount = allCount + numberOfRoom;
                        this.lazyLoader.stop();
                    }

                    lazyRequest.resolve(model);
                }.bind(this),
                error: function(err) {
                    lazyRequest.reject(err);
                }
            });

            return lazyRequest.promise();
        },

        sync: function(method, model, options) {
            this.options = options;

            var params = {
                pageSize: this.itemCount,
                version: this.get('bingoVersion'),
                lobbyName: this.get('config').lobbyName || 'Bingo'
            };

            return method === 'read'
                ? bingoSchedulerUtil.getAll(_.extend(params, this.get('currentFetchParams')))
                : PortletModel.prototype.sync.apply(this, arguments);
        }

    });
});
